<template>
  <div>
    <template v-if="item.name === 'link'">
      <li class="nav-item dropdown">
        <b-link :href="item.params.slug" :target="item.target" class="nav-link">{{ item.title }}</b-link>
      </li>
    </template>
    <template v-else>
      <template v-if="item.child.length">
        <li :class="'nav-item ' + ((isSubItem) ? 'dropdown-submenu' : 'dropdown')">
          <router-link :to="{ name: item.name, params: item.params }" class="nav-link dropdown-toggle">{{ item.title }}</router-link>

          <div class="dropdown-menu">
            <NavItem v-for="(subItem, index) in item.child" :key="index" :item="subItem" :isSubItem="true"></NavItem>
          </div>
        </li>
      </template>
      <template v-else>
        <li class="nav-item">
          <router-link :to="{ name: item.name, params: item.params }" class="nav-link">{{ item.title }}</router-link>
        </li>
      </template>
    </template>
  </div>
</template>

<script>
import NavItem from './NavItem'

export default {
  name: 'NavItem',
  props: {
    item: Object,
    isSubItem: Boolean
  },
  components: {
    NavItem
  }
}
</script>